import { Alert, AlertTitle, Box, Card, CardContent, CardHeader, Stack, Typography } from "@mui/material";
import { NumberInput, TextInput, required } from "react-admin";
import { FinlandConfig, SelectedSite } from "../types";
import { DEFAULT_METRICS_CONFIGS } from "./constants";

interface SiteConfigRowProps {
  prefix: string;
  cfg: FinlandConfig;
}

const SiteConfigRow = ({ prefix, cfg }: SiteConfigRowProps) => {
  return (
    <Box display="grid" gridTemplateColumns="repeat(2, 1fr)" gap={2} marginTop={"0px !important"}>
      <NumberInput source={`${prefix}.range_min`} validate={required()} focused defaultValue={cfg?.range_min} />
      <NumberInput source={`${prefix}.range_max`} validate={required()} focused defaultValue={cfg?.range_max} />
      <TextInput
        source={`${prefix}.direction`}
        defaultValue={cfg.direction}
        // this is a hack to keep input in form values but not visible
        sx={{ display: "none" }}
      />
    </Box>
  );
};

interface SiteConfigRowsProps {
  site: SelectedSite;
  configs: FinlandConfig[];
}

const SiteConfigRows = ({ site, configs }: SiteConfigRowsProps) => {
  return (
    <Stack direction="column" spacing={2} width="100%">
      {configs.map((cfg) => {
        const key = `${site.id}.${cfg.metric}`;
        const defaultCfg = DEFAULT_METRICS_CONFIGS.find((defaultConfig) => defaultConfig.metric === cfg.metric);
        const initialConfig: FinlandConfig = {
          ...cfg,
          range_min: defaultCfg?.range_min ?? cfg.range_min ?? null,
          range_max: defaultCfg?.range_max ?? cfg.range_max ?? null,
        };
        return <SiteConfigRow key={key} prefix={key} cfg={initialConfig} />;
      })}
    </Stack>
  );
};

interface PeAssociationMetricRangesFormProps {
  selectedSites: SelectedSite[];
  configs: FinlandConfig[];
}

const PeAssociationMetricRangesForm = ({ selectedSites, configs }: PeAssociationMetricRangesFormProps) => {
  return (
    <Box>
      <Stack direction="row" flexWrap="wrap" gap={2}>
        {selectedSites.map((site) => (
          <Card
            key={site.id}
            sx={{ width: "100%", border: "1px solid rgba(0, 0, 0, 0.35)", backgroundColor: "#F7FDFF" }}
            variant="outlined"
          >
            <CardHeader title={site.name} />
            <CardContent>
              {configs.length === 0 ? (
                <Alert severity="error" variant="filled" sx={{ mb: 4 }}>
                  <AlertTitle>No configurations found for this PE. </AlertTitle>
                  <Typography variant="caption">
                    This is non blocking but not normal. The following site metrics are generic default metrics values.
                    You should contact the administrator to create the PE configurations before creating the metrics.
                  </Typography>
                </Alert>
              ) : (
                <SiteConfigRows site={site} configs={configs} />
              )}
            </CardContent>
          </Card>
        ))}
      </Stack>
    </Box>
  );
};

export default PeAssociationMetricRangesForm;
